/**
* 基础菜单 大数据
*/
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="搜索：">
                <el-input v-model="formInline.phone" placeholder="输入联系电话" size="small"></el-input>
            </el-form-item>
            <!--      <el-form-item label="">-->
            <!--        <el-input size="small" v-model="formInline.deptNo" placeholder="输入部门代码"></el-input>-->
            <!--      </el-form-item>-->
            <el-form-item>
                <el-button icon="el-icon-search" size="small" type="primary" @click="search">搜索</el-button>
                <el-button icon="el-icon-plus" size="small" type="primary" @click="handleEdit()">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table v-loading="loading" :data="listData" border element-loading-text="拼命加载中" highlight-current-row
                  size="small" style="width: 100%;">
            <el-table-column align="center" type="selection" width="60">
            </el-table-column>
            <el-table-column label="头像" prop="avatar">
                <template slot-scope="scope">
                    <el-avatar :src="scope.row.avatar"></el-avatar>
                </template>
            </el-table-column>
            <el-table-column label="联系人" min-width="120" prop="name" sortable>
            </el-table-column>
            <el-table-column label="联系电话" min-width="120" prop="phone" sortable>
            </el-table-column>
            <el-table-column label="会员状态" prop="phone">
                <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.type"
                        @change="set_vip(scope.row._id.$oid, scope.row.type)"
                    >
                    </el-switch>
                </template>

            </el-table-column>
            <el-table-column align="center" fixed="right" label="操作" min-width="120">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit1(scope.$index, scope.row)">浏览记录</el-button>
                    <br class="mobile-show">
                    <el-button class="mobile-delete" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑
                    </el-button>
                    <br class="mobile-show">
                    <el-button class="mobile-delete" size="mini" type="danger"
                               @click="deleteUser(scope.$index, scope.row)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" class="mobile-dialog" width="30%"
                   @click="closeDialog">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="120px">
                <el-form-item label="头像" prop="avatar">
                    <el-upload
                        :action="baseUrl+'/api/user/uploads'"
                        :before-upload="beforeAvatarUpload"
                        :on-success="handleAvatarSuccess"
                        :show-file-list="false"
                        class="avatar-uploader">
                        <img v-if="editForm.avatar " :src="editForm.avatar" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="联系人" prop="name">
                    <el-input v-model="editForm.name" auto-complete="off" placeholder="请输入联系人" size="small"
                              @input="awdojo()"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="phone">
                    <el-input v-model="editForm.phone" auto-complete="off" placeholder="请输入联系电话" size="small"
                              @input="awdojo()"></el-input>
                    <!-- <input v-model="editForm.phone"  type="" name="" id="" value="" /> -->
                </el-form-item>
                <el-form-item :label="editForm.type ? '修改会员密码' : '添加新会员'" prop="password">
                    <el-input v-model="editForm.password" :placeholder="editForm.type ? '修改会员密码' : '添加新会员'"
                              auto-complete="off" size="small" @input="awdojo()"></el-input>
                    <!-- <input v-model="editForm.phone"  type="" name="" id="" value="" /> -->
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button :loading="loading" class="title" size="small" type="primary" @click="submitForm('editForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="editFormVisible1" title="浏览记录" width="70%" @click="closeDialog">
            <el-table v-loading="loading" :data="infobrowse" border element-loading-text="拼命加载中"
                      highlight-current-row size="small" style="width: 100%;">
                <el-table-column label="头像" min-width="100" prop="avatar">
                    <template slot-scope="scope">
                        <el-avatar :src="scope.row.info.avatar"></el-avatar>
                    </template>
                </el-table-column>
                <el-table-column label="用户名" min-width="150" prop="name" sortable>
                    <template slot-scope="scope">
                        {{ scope.row.info.name }}
                    </template>
                </el-table-column>
                <el-table-column label="浏览分类" min-width="150" prop="name" sortable>
                </el-table-column>
                <el-table-column label="详情名称" min-width="150" prop="goods" sortable>
                </el-table-column>
                <el-table-column label="联系电话" min-width="150" prop="phone" sortable>
                </el-table-column>
                <el-table-column label="浏览时间" min-width="150" prop="browse_time" sortable>
                    <template slot-scope="scope">
                        {{ scope.row.browse_time }}秒
                    </template>
                </el-table-column>
                <el-table-column label="点击次数" min-width="150" prop="click" sortable>
                </el-table-column>
                <el-table-column label="上次访问日期" min-width="150" prop="time" sortable>
                </el-table-column>

            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <!-- <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button> -->
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {usersList, usersSave, usersDelete, infobrowse, userSetVip} from '../../api/userMG'
import Pagination from '../../components/Pagination'

export default {
    data() {
        return {
            baseUrl: '',
            nshow: true, //switch开启
            fshow: false, //switch关闭
            loading: false, //是显示加载
            editFormVisible: false, //控制编辑页面显示与隐藏
            editFormVisible1: false,
            title: '添加',
            editForm: {
                token: localStorage.getItem('logintoken'),
                ids: '',
                avatar: '',
                name: '',
                phone: '',
                type: false,
                password: ''
            },
            // rules表单验证
            rules: {
                avatar: [
                    {required: true, message: '头像', trigger: 'blur'}
                ],
                name: [
                    {required: true, message: '联系人', trigger: 'blur'},
                ],
                phone: [
                    {required: true, message: '联系电话', trigger: 'blur'},
                ]
            },
            formInline: {
                page: 1,
                limit: 10,
                varLable: '',
                varName: '',
                token: localStorage.getItem('logintoken'),
                phone: '',
            },
            // 删除部门
            seletedata: {
                ids: '',
                token: localStorage.getItem('logintoken')
            },
            userparm: [], //搜索权限
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            }
        }
    },
    // 注册组件
    components: {
        Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
        this.getdata(this.formInline)
        this.baseUrl = this.$config.baseUrl
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
        handleAvatarSuccess(res, file) {
            this.editForm.avatar = URL.createObjectURL(file.raw);
            this.editForm.avatar1 = res
            this.$message.success("上传成功");
            this.$forceUpdate()
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            this.$message.warning("上传中");
            return isJPG && isLt2M;
        },
        awdojo() {
            this.$forceUpdate()
        },
        // 获取公司列表
        getdata(parameter) {
            this.loading = true
            /***
             * 调用接口，注释上面模拟数据 取消下面注释
             */
            usersList(parameter)
                .then(res => {
                    this.loading = false
                    if (res.success == false) {
                        this.$message({
                            type: 'info',
                            message: res.msg
                        })
                    } else {
                        this.listData = res.data
                        // 分页赋值
                        this.pageparm.currentPage = this.formInline.page
                        this.pageparm.pageSize = this.formInline.limit
                        this.pageparm.total = res.count
                    }
                })
                .catch(err => {
                    this.loading = false
                    this.$message.error('菜单加载失败，请稍后再试！')
                })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
        // 搜索事件
        search() {
            this.getdata(this.formInline)
        },
        handleEdit1: function (index, row) {
            this.loading = true
            this.editFormVisible1 = true
            infobrowse({phone: row.phone}).then(res => {
                this.loading = false
                this.infobrowse = res.data
            })

        },
        //显示编辑界面
        handleEdit: function (index, row) {
            this.editFormVisible = true
            if (row != undefined && row != 'undefined') {
                this.title = '修改'
                this.editForm.ids = row._id.$oid
                this.editForm.avatar = row.avatar
                this.editForm.avatar1 = ''
                this.editForm.name = row.name
                this.editForm.phone = row.phone
                this.editForm.password = ''
                this.editForm.type = row.type

            } else {
                this.title = '添加'
                this.editForm.ids = ''
                this.editForm.avatar = ''
                this.editForm.name = ''
                this.editForm.phone = ''
                this.editForm.type = false
                this.editForm.password = ''
                this.editForm.avatar1 = ''
            }
        },
        // 编辑、增加页面保存方法
        submitForm(editData) {
            this.$refs[editData].validate(valid => {
                if (valid) {
                    usersSave(this.editForm)
                        .then(res => {
                            this.editFormVisible = false
                            this.loading = false
                            if (res.success) {
                                this.getdata(this.formInline)
                                this.$message({
                                    type: 'success',
                                    message: '信息保存成功！'
                                })
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: res.msg
                                })
                            }
                        })
                        .catch(err => {
                            this.editFormVisible = false
                            this.loading = false
                            this.$message.error('信息保存失败，请稍后再试！')
                        })
                } else {
                    return false
                }
            })
        },
        // 删除公司
        deleteUser(index, row) {
            this.$confirm('确定要删除吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {

                    usersDelete(row._id.$oid)
                        .then(res => {
                            if (res.success) {
                                this.$message({
                                    type: 'success',
                                    message: '用户已删除!'
                                })
                                this.getdata(this.formInline)
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: res.msg
                                })
                            }
                        })
                        .catch(err => {
                            this.loading = false
                            this.$message.error('用户删除失败，请稍后再试！')
                        })
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        // 关闭编辑、增加弹出框
        closeDialog() {
            this.editFormVisible1 = false
            this.editFormVisible = false
        },
        // 设置用户vip
        set_vip(user_id, is_vip = false){
            userSetVip({
                user_id: user_id,
                is_vip: is_vip ? 1 : 0
            }).then(res => {
                console.log(res);
            })
        },
    }
}
</script>

<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.user-search {
    margin-top: 20px;
}

.userRole {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/user/user.vue